import type { NotificationApiResponse } from '@/domains/notification/notification.entity';
import type { NotificationRepository } from '@/domains/notification/notification.repository';
import { notificationApiService } from '../http/notification.api';

/**
 * Implementación del repositorio de notificaciones usando API service
 *
 * @remarks
 * Actúa como intermediario entre el dominio y la capa HTTP,
 * validando las respuestas del API antes de devolverlas
 */
class NotificationApiRepository implements NotificationRepository {
  /**
   * Obtiene los tipos de notificaciones pendientes del usuario
   * @throws Error si no se obtienen datos válidos del API
   */
  // async getPendingNotifications(): Promise<NotificationType[]> {
  //   const response = await notificationApiService.getPendingNotifications();
  //
  //   if (!response || !response.success) {
  //     throw new Error('Error al obtener notificaciones pendientes');
  //   }
  //
  //   return response.pendientes;
  // }

  async getNotifications(
    cod_funcionario: number,
  ): Promise<NotificationApiResponse> {
    const response =
      await notificationApiService.getNotifications(cod_funcionario);

    if (!response || !response.success)
      throw new Error('Error al obtener registro para notificaciones');

    return response;
  }
}

export const notificationApiRepository = new NotificationApiRepository();
